import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../../../config";
import "../Styles/PlanillarPartidoComponent.css";
import { Button, Modal } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import defaulUser from "../../../assets/defaultUser.png"
import CheckListJugadores from "./CheckListJugadores";

const PlanillarPartidoComponent = ({ idPartido, idEquipo }) => {
  const [personas, setPersonas] = useState([]);
  const [busqueda, setBusqueda] = useState("");
  const [personaEncontrada, setPersonaEncontrada] = useState(null);
  const [error, setError] = useState("");
  const [estadisticas, setEstadisticas] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [inicialista, setInicialista] = useState(false);
  const [modalCheckVisible, setModalCheckVisible] = useState(false);

  const [numeroDorsal, setNumeroDorsal] = useState("");
  const [nombres, setNombres] = useState("");
  const [identificacion, setIdentificacion] = useState("");
  const [delegacion, setDelegacion] = useState("");
  const [modalPersonaVisible, setModalPersonaVisible] = useState(false);

  const abrirModalCheck = () => setModalCheckVisible(true);
  const cerrarModalCheck = () => setModalCheckVisible(false);

  const obtenerPersonas = useCallback(async () => {
    try {
      const response = await axios.get(`${BASE_URL}personas`);
      setPersonas(response.data);
    } catch (error) {
      console.error(error);
    }
  }, []);

  const obtenerEstadisticas = useCallback(async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}get-estadisticas-partido/${idPartido}/${idEquipo}`
      );
      setEstadisticas(response.data);
    } catch (error) {
      console.error(error);
    }
  }, [idPartido, idEquipo]);

  useEffect(() => {
    obtenerPersonas();
    obtenerEstadisticas();
  }, [obtenerPersonas, obtenerEstadisticas]);

  const manejarCambioBusqueda = (e) => {
    setBusqueda(e.target.value);
  };

  const buscarPersona = () => {
    const persona = personas.find(
      (persona) => persona.identificacion === busqueda
    );
    if (persona) {
      setPersonaEncontrada(persona);
      setError("");
    } else {
      setPersonaEncontrada(null);
      setError("No se encontró ninguna persona con esa identificación.");
    }
  };

  const agregarPersona = async () => {
    if (!personaEncontrada || numeroDorsal < 1 || numeroDorsal > 100) {
      setError("El número dorsal debe estar entre 1 y 100");
      toast.error("El número dorsal debe estar entre 1 y 100");
      return false;
    }

    const data = {
      idPersona: personaEncontrada.id,
      idPartido,
      idEquipo,
      inicialista: inicialista,
      numeroDorsal,
    };

    try {
      const response = await axios.post(`${BASE_URL}store-planilla`, data);
      if (response.status === 200) {
        toast.success("Persona agregada exitosamente");
        setError("");
        setModalVisible(false);
        setBusqueda("");
        setNumeroDorsal("");
        setPersonaEncontrada(null);
        obtenerEstadisticas();
        return true;
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Error al agregar persona al partido";
      toast.error(errorMessage);
      return false;
    }
  };

  const enviarFormularioPersona = async () => {
    const datosPersona = {
      nombres,
      identificacion,
      delegacion,
    };

    try {
      const response = await axios.post(
        `${BASE_URL}store-persona`,
        datosPersona
      );

      if (response.status === 200) {
        setModalPersonaVisible(false);
        setNombres("");
        setIdentificacion("");
        setDelegacion("");
        toast.success("Persona agregada exitosamente");
        obtenerPersonas();
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Error al enviar los datos a store-persona";
      toast.error(errorMessage);
      console.error("Error al enviar los datos a store-persona:", error);
    }
  };

  const abrirModal = () => {
    setModalVisible(true);
    setInicialista(false);
    setNumeroDorsal("");
  };

  return (
    <div className="container mt-4">
      <ToastContainer />
      <div className="mb-3 row">
        <div className="col-sm-10">
          <input
            type="text"
            className="form-control"
            placeholder="Buscar por identificación"
            value={busqueda}
            onChange={manejarCambioBusqueda}
          />
        </div>
        <div className="col-sm-2">
          <button className="btn btn-primary" onClick={buscarPersona}>
            Buscar
          </button>
        </div>

        <button
          className="btn btn-secondary mt-2"
          style={{ width: "150px", marginLeft: "12px" }}
          onClick={() => {
            setModalPersonaVisible(true);
            setNombres("");
            setIdentificacion("");
            setDelegacion("");
          }}
        >
          Nuevo Jugador
        </button>

        <button
          className="btn btn-secondary mt-2"
          style={{ width: "150px", marginLeft: "12px" }}
          onClick={abrirModalCheck}
        >
          Asistencia
        </button>
      </div>

      {personaEncontrada ? (
        <div className="card mt-1">
          <div className="card-body d-flex justify-content-between align-items-center">
            <div>
              <h5 className="card-title">Información del Deportista:</h5>
              <p className="card-text">Nombre: {personaEncontrada.nombres}</p>

              <p className="card-text">
                Identificación: {personaEncontrada.identificacion}
              </p>
            </div>

            <div>
              <img
                src={personaEncontrada.fotografiaPath || defaulUser}
                alt={`${personaEncontrada.nombreJugador} Foto`}
                className="goleador-search"
              />
            </div>

            <button className="btn btn-success" onClick={abrirModal}>
              Agregar
            </button>
          </div>
        </div>
      ) : (
        error && <p className="text-danger mt-3">{error}</p>
      )}

      <h5 className="mt-4">Jugadores del partido</h5>
      <table className="table table-bordered mt-3">
        <thead>
          <tr>
            <th scope="col">Nombre</th>
            <th scope="col">Inicialista</th>
            <th scope="col">
              T.A
              <span className="tarjeta-amarela" />
            </th>
            <th scope="col">
              T.R
              <span className="tarjeta-roja" />
            </th>
            <th scope="col">Puntos</th>
          </tr>
        </thead>
        <tbody>
          {estadisticas.map((estadistica) => (
            <tr key={estadistica.id}>
              <td>
                {estadistica.jugador.nombres} {estadistica.jugador.apellidos} #
                {estadistica.numeroCamiseta}
              </td>
              <td>
                {estadistica.inicialista === "1" ||
                estadistica.inicialista === 1
                  ? "Sí"
                  : "No"}
              </td>
              <td>{estadistica.tarjetaAmarilla}</td>
              <td>{estadistica.tarjetaRoja}</td>
              <td>{estadistica.puntos}</td>
            </tr>
          ))}
          {estadisticas.length === 0 && (
            <tr>
              <td colSpan="6" className="text-center">
                No hay estadísticas disponibles
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <Modal show={modalVisible} onHide={() => setModalVisible(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Agregar Persona al Partido</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              agregarPersona();
            }}
          >
            <div className="form-group">
              <label>
                Inicialista:
                <input
                  type="checkbox"
                  style={{ marginLeft: "10px" }}
                  className="form-check-input ml-2"
                  checked={inicialista}
                  onChange={(e) => setInicialista(e.target.checked)}
                />
              </label>
            </div>

            <div className="form-group">
              <label>
                Número Dorsal (1-100):
                <input
                  type="number"
                  className="form-control ml-2 mt-2"
                  min="1"
                  max="100"
                  value={numeroDorsal}
                  onChange={(e) => setNumeroDorsal(Number(e.target.value))}
                />
              </label>

              {numeroDorsal < 1 || numeroDorsal > 100 ? (
                <small className="text-danger">
                  El número debe estar entre 1 y 100
                </small>
              ) : null}
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setModalVisible(false)}>
            Cerrar
          </Button>
          <Button variant="primary" onClick={agregarPersona}>
            Agregar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={modalPersonaVisible}
        onHide={() => setModalPersonaVisible(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Agregar Nueva Persona</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              enviarFormularioPersona();
            }}
          >
            <div className="form-group">
              <label>Nombres:</label>
              <input
                type="text"
                className="form-control"
                value={nombres}
                onChange={(e) => setNombres(e.target.value)}
                required
              />
            </div>
            <div className="form-group mt-3">
              <label>Identificación:</label>
              <input
                type="text"
                className="form-control"
                value={identificacion}
                onChange={(e) => setIdentificacion(e.target.value)}
                required
              />
            </div>
            <div className="form-group mt-3">
              <label>Delegación:</label>
              <input
                type="text"
                className="form-control"
                value={delegacion}
                onChange={(e) => setDelegacion(e.target.value)}
                required
              />
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setModalPersonaVisible(false)}
          >
            Cerrar
          </Button>
          <Button variant="primary" onClick={enviarFormularioPersona}>
            Enviar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal  show={modalCheckVisible} onHide={cerrarModalCheck} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Asistencia Jugadores</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CheckListJugadores idEquipo={idEquipo}
            idPartido={idPartido}/>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={cerrarModalCheck}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>

    
  );
};

export { PlanillarPartidoComponent };
